(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 89208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(62532);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _styles_fontStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30423);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15840);





function EmptyStateArea(param) {
    var imageUrl = param.imageUrl, svg = param.svg, imageName = param.imageName, emptyText = param.emptyText, buttonText = param.buttonText, _buttonColor = param.buttonColor, buttonColor = _buttonColor === void 0 ? "primary" : _buttonColor, onClick = param.onClick, href = param.href, _marginTop = param.marginTop, marginTop = _marginTop === void 0 ? "24px" : _marginTop;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(EmptyStateWrapper, {
        marginTop: marginTop,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                className: "empty-state-image",
                children: [
                    imageUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("img", {
                        src: imageUrl,
                        alt: imageName
                    }),
                    svg
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(EmptyStateText, {
                children: emptyText
            }),
            buttonText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                color: buttonColor,
                size: "medium",
                type: "button",
                onClick: onClick,
                href: href,
                children: buttonText
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (EmptyStateArea);
var EmptyStateWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("section", {
    target: "e1uan8zu0"
})("display:flex;flex-direction:column;align-items:center;margin-top:", function(param) {
    var marginTop = param.marginTop;
    return marginTop;
}, ";.empty-state-image{margin-bottom:24px;}");
var EmptyStateText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e1uan8zu1"
})("margin-bottom:16px;white-space:pre-line;text-align:center;", (0,_styles_fontStyles__WEBPACK_IMPORTED_MODULE_4__/* .h3Font */ .rJ)(true), ";color:", function(param) {
    var theme = param.theme;
    return theme.accent5;
}, ";");


/***/ }),

/***/ 97078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95934);
/* harmony import */ var _styles_fontStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30423);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function HelperMessage(param) {
    var isError = param.isError, message = param.message;
    if (!message) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(HelperText, {
        isError: isError,
        children: message
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (HelperMessage);
var HelperText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("small", {
    target: "e1nd61bn0"
})((0,_styles_fontStyles__WEBPACK_IMPORTED_MODULE_4__/* .subtitle1Font */ .T7)(), "  margin:6px 0px 0px 4px;transition:color .2s ease-in-out;", function(param) {
    var isError = param.isError, theme = param.theme;
    return isError ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), theme.warning) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject1(), theme.accent5);
}, ";");


/***/ }),

/***/ 84138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95934);
/* harmony import */ var _styles_fontStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30423);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function Label(param) {
    var labelText = param.labelText, htmlFor = param.htmlFor, isError = param.isError, labelOptionText = param.labelOptionText;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledLabel, {
        htmlFor: htmlFor,
        isError: isError,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("span", {
            children: [
                labelText,
                labelOptionText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                    className: "option-span",
                    children: "(".concat(labelOptionText, ")")
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Label);
var StyledLabel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("label", {
    target: "e57obbe0"
})("& > span{", (0,_styles_fontStyles__WEBPACK_IMPORTED_MODULE_4__/* .body2Font */ .ll)(true), "    display:inline-flex;transition:color .2s ease-in-out;margin:0px 0px 6px 4px;", function(param) {
    var isError = param.isError, theme = param.theme;
    return isError ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), theme.warning) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject1(), theme.accent6);
}, ";}.option-span{", (0,_styles_fontStyles__WEBPACK_IMPORTED_MODULE_4__/* .body2Font */ .ll)(), ";color:", function(param) {
    var theme = param.theme;
    return theme.accent4;
}, ";margin-left:4px;}");


/***/ }),

/***/ 84698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43337);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55208);



var useCurrentTime = function(group) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(Date.now()), currentTime = ref[0], setCurrentTime = ref[1];
    var delay = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!group) {
            return null;
        }
        if ((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .isRecruitCompletedAndManual */ .El)(group)) {
            return null;
        }
        if ((0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .isCurrentTimeBeforeEndDate */ .sy)(group.recruitmentEndDate, currentTime)) {
            return 1000;
        }
        return null;
    }, [
        group,
        currentTime
    ]);
    (0,react_use__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return setCurrentTime(Date.now());
    }, delay);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return currentTime;
    }, [
        currentTime
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useCurrentTime);


/***/ }),

/***/ 2497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55208);
/* harmony import */ var _useCurrentTime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84698);




var useRecruitDateStatus = function(group) {
    var currentTime = (0,_useCurrentTime__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(group);
    var recruitmentEndDate = group.recruitmentEndDate, createdAt = group.createdAt;
    var createdDate = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(createdAt).format("YYYY\uB144 MM\uC6D4 DD\uC77C");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(createdDate), recruitDateStatus = ref[0], setRecruitDateStatus = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .isRecruitCompletedAndManual */ .El)(group)) {
            setRecruitDateStatus(createdDate);
            return;
        }
        if ((0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .isCurrentTimeBeforeEndDate */ .sy)(recruitmentEndDate, currentTime)) {
            setRecruitDateStatus("".concat(dayjs__WEBPACK_IMPORTED_MODULE_1___default()(currentTime).to(dayjs__WEBPACK_IMPORTED_MODULE_1___default()(recruitmentEndDate)), " \uB9C8\uAC10"));
            return;
        }
        setRecruitDateStatus(createdDate);
    }, [
        group,
        createdDate,
        currentTime,
        recruitmentEndDate
    ]);
    return recruitDateStatus;
};
/* harmony default export */ __webpack_exports__["Z"] = (useRecruitDateStatus);


/***/ }),

/***/ 78016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22659);



function useRenderErrorToast(param) {
    var errorMessage = param.errorMessage, errorStatus = param.errorStatus, replaceUrl = param.replaceUrl;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(), replace = ref.replace, query = ref.query;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((query === null || query === void 0 ? void 0 : query.error) === errorStatus) {
            (0,_utils_toast__WEBPACK_IMPORTED_MODULE_2__/* .errorToast */ .Jc)(errorMessage);
            replace(replaceUrl, undefined, {
                shallow: true
            });
        }
    }, [
        query === null || query === void 0 ? void 0 : query.error,
        errorMessage,
        errorStatus,
        replaceUrl,
        replace
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useRenderErrorToast);


/***/ }),

/***/ 62532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/containers/common/HeaderContainer.tsx + 5 modules
var HeaderContainer = __webpack_require__(89104);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./src/utils/utils.ts
var utils = __webpack_require__(55208);
;// CONCATENATED MODULE: ./src/assets/icons/empty-frame.svg
var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgEmptyFrame = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 80,
  height: 80,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M76 43.322c0 5.153-3.793 4.666-8.47 4.666H12.47c-4.677 0-8.47.487-8.47-4.666l4.235-27.991C8.5 10.859 12.028 6 16.705 6h46.59c4.677 0 8.027 5.15 8.47 9.33L76 43.323Z",
  fill: "#67757F"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M76 67.53A8.47 8.47 0 0 1 67.53 76H12.47A8.47 8.47 0 0 1 4 67.53V44.234a8.471 8.471 0 0 1 8.47-8.47h55.06a8.471 8.471 0 0 1 8.47 8.47V67.53Z",
  fill: "#9AAAB4"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M54.824 61.176a4.237 4.237 0 0 1-4.236 4.236H29.412a4.237 4.237 0 0 1-4.235-4.236V50.588a4.237 4.237 0 0 1 4.235-4.235h21.176a4.237 4.237 0 0 1 4.236 4.235v10.588Z",
  fill: "#67757F"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M50.588 59.059a2.116 2.116 0 0 1-2.117 2.117H31.529a2.117 2.117 0 0 1-2.117-2.117v-6.353c0-1.171.948-2.118 2.117-2.118h16.942c1.17 0 2.117.947 2.117 2.118v6.353Z",
  fill: "#E1E8ED"
})));

/* harmony default export */ var empty_frame = (SvgEmptyFrame);
// EXTERNAL MODULE: ./src/components/common/EmptyStateArea.tsx
var EmptyStateArea = __webpack_require__(16773);
// EXTERNAL MODULE: ./node_modules/react-feather/dist/icons/eye.js
var eye = __webpack_require__(12590);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js + 2 modules
var emotion_element_cbed451f_browser_esm = __webpack_require__(9570);
// EXTERNAL MODULE: ./src/hooks/useRecruitDateStatus.ts
var useRecruitDateStatus = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/styles/Divider.tsx
var Divider = __webpack_require__(4405);
// EXTERNAL MODULE: ./src/styles/fontStyles.ts
var fontStyles = __webpack_require__(30423);
// EXTERNAL MODULE: ./src/styles/responsive.ts
var responsive = __webpack_require__(50811);
// EXTERNAL MODULE: ./src/utils/filter.ts
var filter = __webpack_require__(28598);
// EXTERNAL MODULE: ./src/components/common/ProfileImage.tsx
var ProfileImage = __webpack_require__(52235);
;// CONCATENATED MODULE: ./src/components/home/RecruitPost.tsx













function RecruitPost(param) {
    var group = param.group;
    var title = group.title, content = group.content, groupId = group.groupId, writer = group.writer, views = group.views, shortDescription = group.shortDescription, thumbnail = group.thumbnail;
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var recruitDate = (0,useRecruitDateStatus/* default */.Z)(group);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RecruitPostWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/detail/".concat(groupId),
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RecruitPostContents, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PostPreview, {
                            children: [
                                thumbnail && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThumbnailWrapper, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Thumbnail, {
                                        src: thumbnail,
                                        alt: "thumbnail"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                    children: title
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
                                    hasThumbnail: !!thumbnail,
                                    children: (0,utils/* emptyAThenB */.wp)((0,filter/* removeAllHtml */.L)(content), shortDescription)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PostMetaData, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(eye/* default */.Z, {
                                    size: 16,
                                    color: theme.background,
                                    fill: theme.accent6
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: views
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: recruitDate
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PostWriter, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileImage/* default */.Z, {
                        size: "24px",
                        src: writer.image
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: (0,utils/* emptyAThenB */.wp)(writer.email, writer.name)
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var home_RecruitPost = (/*#__PURE__*/(0,react.memo)(RecruitPost));
var RecruitPostWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ekb6ld0"
})((0,responsive/* mq2 */.v6)({
    width: [
        "100%",
        "100%",
        "calc(50% - 1.5rem)",
        "245px",
        "245px"
    ]
}), ";display:flex;flex-direction:column;overflow:hidden;height:346px;margin:0.625rem;border-radius:8px;background-color:", function(param) {
    var theme = param.theme;
    return theme.background;
}, ";");
var RecruitPostContents = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1ekb6ld1"
})("height:100%;display:flex;flex-direction:column;justify-content:space-between;padding:16px 16px 12px;");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ekb6ld2"
})((0,fontStyles/* h4Font */.QY)(true), ";");
var Content = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ekb6ld3"
})((0,fontStyles/* body2Font */.ll)(), ";color:", function(param) {
    var theme = param.theme;
    return theme.accent7;
}, ";word-break:break-all;overflow-wrap:break-word;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:", function(param) {
    var hasThumbnail = param.hasThumbnail;
    return hasThumbnail ? 2 : 4;
}, ";-webkit-box-orient:vertical;overflow:hidden;");
var PostMetaData = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ekb6ld4"
})("display:flex;flex-direction:row;align-items:center;", (0,fontStyles/* subtitle1Font */.T7)(), ";color:", function(param) {
    var theme = param.theme;
    return theme.accent6;
}, ";& > svg{margin-right:4px;}");
var PostPreview = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ekb6ld5"
})("& >:not(div:last-of-type){margin-bottom:6px;}");
var PostWriter = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ekb6ld6"
})("display:flex;flex-direction:row;align-items:center;padding:12px 16px;border-top:1px solid ", function(param) {
    var theme = param.theme;
    return theme.accent1;
}, ";", (0,fontStyles/* subtitle1Font */.T7)(true), ";& >:first-of-type{margin-right:8px;}");
var Thumbnail = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("img", {
    target: "e1ekb6ld7"
})("position:absolute;top:0px;left:0px;width:100%;height:100%;display:block;object-fit:cover;");
var ThumbnailWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ekb6ld8"
})("margin:-16px -16px 16px -16px !important;position:relative;padding-top:136px;");

;// CONCATENATED MODULE: ./src/components/home/RecruitPosts.tsx







function RecruitPosts(param) {
    var groups = param.groups, onClickEmptyButton = param.onClickEmptyButton;
    if ((0,utils/* isEmpty */.xb)(groups)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyStateArea/* default */.Z, {
            emptyText: "\uBAA8\uC9D1 \uC911\uC778 \uD300\uC774 \uC5C6\uC5B4\uC694.\n        \uC0C8\uB85C\uC6B4 \uD300\uC744 \uBAA8\uC9D1\uD574\uBCFC\uAE4C\uC694?",
            buttonText: "\uD300 \uBAA8\uC9D1\uD558\uAE30",
            svg: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(empty_frame, {}),
            marginTop: "80px",
            buttonColor: "outlined",
            onClick: onClickEmptyButton
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecruitPostsWrapper, {
        children: groups.map(function(group) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(home_RecruitPost, {
                group: group
            }, group.groupId);
        })
    });
}
/* harmony default export */ var home_RecruitPosts = (/*#__PURE__*/(0,react.memo)(RecruitPosts));
var RecruitPostsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1m9hksg0"
})("display:flex;flex-wrap:wrap;margin:-0.625rem;");

// EXTERNAL MODULE: ./src/components/common/SkeletonItem.tsx
var SkeletonItem = __webpack_require__(71178);
;// CONCATENATED MODULE: ./src/components/home/RecruitPostsSkeletonLoader.tsx






function RecruitPostsSkeletonLoader() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecruitPostsWrapper, {
        title: "loading...",
        children: Array.from({
            length: 12
        }, function(_, i) {
            return i;
        }).map(function(key) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SkeletonBlock, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "contents",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "thumbnail-skeleton-wrapper",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonItem/* default */.Z, {
                                            className: "thumbnail-skeleton",
                                            styles: {
                                                borderRadius: "0"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "post-description-skeleton",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonItem/* default */.Z, {
                                            styles: {
                                                height: "24px",
                                                width: "160px",
                                                margin: "0 0 12px 0",
                                                borderRadius: "6px"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "post-description-skeleton",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonItem/* default */.Z, {
                                            styles: {
                                                height: "18px",
                                                width: "213px",
                                                margin: "0 0 8px 0"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "post-description-skeleton",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonItem/* default */.Z, {
                                            styles: {
                                                height: "18px",
                                                width: "100px"
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonItem/* default */.Z, {
                                styles: {
                                    height: "14px",
                                    width: "64px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PostWriter, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonItem/* default */.Z, {
                                styles: {
                                    height: "24px",
                                    width: "24px",
                                    minWidth: "24px",
                                    minHeight: "24px"
                                },
                                circle: true
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonItem/* default */.Z, {
                                styles: {
                                    height: "14px",
                                    width: "64px"
                                }
                            })
                        ]
                    })
                ]
            }, key);
        })
    });
}
/* harmony default export */ var home_RecruitPostsSkeletonLoader = (RecruitPostsSkeletonLoader);
var SkeletonBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(RecruitPostWrapper, {
    target: "emy2o610"
})("& > .contents{height:100%;display:flex;flex-direction:column;justify-content:space-between;padding:16px 16px 12px;& > div{& > .thumbnail-skeleton-wrapper{margin:-16px -16px 16px -16px !important;position:relative;overflow:hidden;padding-top:136px;& > .thumbnail-skeleton{position:absolute;top:0;left:0;width:100%;height:100%;}}& > .post-description-skeleton{width:100%;}}}");

// EXTERNAL MODULE: ./src/hooks/api/auth/useFetchUserProfile.ts
var useFetchUserProfile = __webpack_require__(8576);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/recoil/group/atom.ts
var atom = __webpack_require__(84029);
// EXTERNAL MODULE: ./src/services/api/group.ts + 2 modules
var group = __webpack_require__(27887);
// EXTERNAL MODULE: ./src/hooks/api/useCatchFirestoreErrorWithToast.ts
var useCatchFirestoreErrorWithToast = __webpack_require__(15989);
;// CONCATENATED MODULE: ./src/hooks/api/group/useFetchGroups.ts








function useFetchGroups() {
    var groupsCondition = (0,es/* useRecoilValue */.sJ)(atom/* groupsConditionState */.c);
    var query = (0,useQuery/* useQuery */.a)([
        "groups",
        groupsCondition
    ], function() {
        return (0,group/* fetchGroups */.bt)(groupsCondition);
    });
    var isError = query.isError, error = query.error, data = query.data;
    (0,useCatchFirestoreErrorWithToast/* default */.Z)({
        isError: isError,
        error: error,
        defaultErrorMessage: "\uD300 \uB9AC\uC2A4\uD2B8\uB97C \uBD88\uB7EC\uC624\uB294\uB370 \uC2E4\uD328\uD588\uC5B4\uC694! \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694!"
    });
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
        data: (0,utils/* checkEmpty */.TM)(data)
    });
}
/* harmony default export */ var group_useFetchGroups = (useFetchGroups);

// EXTERNAL MODULE: ./src/hooks/useRenderErrorToast.ts
var useRenderErrorToast = __webpack_require__(78016);
// EXTERNAL MODULE: ./src/recoil/modal/atom.ts
var modal_atom = __webpack_require__(68453);
;// CONCATENATED MODULE: ./src/containers/home/RecruitPostsContainer.tsx











function RecruitPostsContainer() {
    var push = (0,router.useRouter)().push;
    var ref = group_useFetchGroups(), groups = ref.data, isLoading = ref.isLoading;
    var ref1 = (0,useFetchUserProfile/* default */.Z)(), user = ref1.data;
    var setSignInModalVisible = (0,es/* useSetRecoilState */.Zl)(modal_atom/* signInModalVisibleState */.PJ);
    (0,useRenderErrorToast/* default */.Z)({
        errorStatus: "unauthenticated",
        errorMessage: "\uC811\uADFC \uAD8C\uD55C\uC774 \uC5C6\uB294 \uD398\uC774\uC9C0\uC5D0\uC694.",
        replaceUrl: "/"
    });
    var onClickEmptyButton = (0,react.useCallback)(function() {
        if (user) {
            push("/write");
            return;
        }
        setSignInModalVisible(true);
    }, [
        user
    ]);
    if (isLoading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecruitPostsContainer_RecruitPostsWrapper, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(home_RecruitPostsSkeletonLoader, {})
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecruitPostsContainer_RecruitPostsWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(home_RecruitPosts, {
            groups: groups,
            onClickEmptyButton: onClickEmptyButton
        })
    });
}
/* harmony default export */ var home_RecruitPostsContainer = (RecruitPostsContainer);
var RecruitPostsContainer_RecruitPostsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("main", {
    target: "e6dxpu50"
})("flex:1 1 0%;margin-bottom:3rem;");

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useLocalStorage.js
var useLocalStorage = __webpack_require__(90584);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/common/SelectBox.tsx
var SelectBox = __webpack_require__(58811);
;// CONCATENATED MODULE: ./src/components/home/FilterBar.tsx



var filterOption = [
    {
        label: "\uC804\uCCB4",
        value: "all"
    },
    {
        label: "\uC2A4\uD130\uB514",
        value: "study"
    },
    {
        label: "\uD504\uB85C\uC81D\uD2B8",
        value: "project"
    }, 
];
function FilterBar(param) {
    var onChange = param.onChange, filterCategory = param.filterCategory;
    var categoryValue = {
        "project,study": filterOption[0],
        "study,project": filterOption[0],
        study: filterOption[1],
        project: filterOption[2]
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectBox/* default */.Z, {
            id: "filter-post",
            defaultValue: filterOption[0],
            value: categoryValue[filterCategory.join()],
            onChange: onChange,
            options: filterOption,
            size: "medium"
        })
    });
}
/* harmony default export */ var home_FilterBar = (FilterBar);

// EXTERNAL MODULE: ./node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(53416);
;// CONCATENATED MODULE: ./src/components/home/skeleton/TagsBarSkeletonLoader.tsx





function TagsBarSkeletonLoader() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsBarSkeletonLoaderWrapper, {
        title: "loading...",
        children: [
            "80px",
            "120px",
            "80px",
            "80px",
            "120px",
            "64px"
        ].map(function(width) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonItem/* default */.Z, {
                styles: {
                    height: "36px",
                    width: width,
                    borderRadius: "6px"
                }
            }, (0,index_browser/* nanoid */.x0)());
        })
    });
}
/* harmony default export */ var skeleton_TagsBarSkeletonLoader = (TagsBarSkeletonLoader);
var TagsBarSkeletonLoaderWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1dtr85m0"
})("height:36px;overflow:hidden;& >:not(:last-of-type){margin-right:8px;}");

// EXTERNAL MODULE: ./src/hooks/useResponsive.ts
var useResponsive = __webpack_require__(10653);
;// CONCATENATED MODULE: ./src/containers/home/StatusBarContainer.tsx














var TagsBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 234).then(__webpack_require__.bind(__webpack_require__, 43234));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43234)
            ];
        }
    },
    suspense: true
});
var SwitchButton = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 189).then(__webpack_require__.bind(__webpack_require__, 52189));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52189)
            ];
        }
    },
    ssr: false
});
function StatusBarContainer() {
    var ref = (0,useResponsive/* default */.Z)(), isMobile = ref.isMobile, isClient = ref.isClient;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useLocalStorage/* default */.Z)("isFilterCompleted", false), 2), initFilterCompleted = ref1[0], toggleFilterCompleted = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,es/* useRecoilState */.FV)(atom/* groupsConditionState */.c), 2), ref3 = ref2[0], isFilterCompleted = ref3.isFilterCompleted, filterCategory = ref3.category, setCondition = ref2[1];
    var setGroupsCondition = function(condition) {
        return setCondition(function(prevCondition) {
            return (0,_object_spread/* default */.Z)({}, prevCondition, condition);
        });
    };
    var onChange = (0,react.useCallback)(function(category) {
        if (category === "all") {
            setGroupsCondition({
                category: [
                    "study",
                    "project"
                ]
            });
            return;
        }
        setGroupsCondition({
            category: [
                category
            ]
        });
    }, [
        setGroupsCondition
    ]);
    var onToggle = function(isWithCompleted) {
        setGroupsCondition({
            isFilterCompleted: isWithCompleted
        });
        toggleFilterCompleted(isWithCompleted);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StatusBarWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(home_FilterBar, {
                        filterCategory: filterCategory,
                        onChange: onChange
                    }),
                    isClient && !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Suspense, {
                                fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(skeleton_TagsBarSkeletonLoader, {}),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsBar, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RecruitmentDeadline, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: "\uBAA8\uC9D1 \uB9C8\uAC10 \uC548\uBCF4\uAE30"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SwitchButton, {
                        defaultChecked: !!initFilterCompleted,
                        onChange: function() {
                            return onToggle(!isFilterCompleted);
                        }
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var home_StatusBarContainer = (StatusBarContainer);
var StatusBarWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9fhi70"
})("display:flex;flex-direction:row;justify-content:space-between;align-items:center;margin-bottom:20px;margin-top:9px;& > div:first-of-type{display:flex;flex-direction:row;align-items:center;}");
var RecruitmentDeadline = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9fhi71"
})("min-width:171px;display:flex;flex-direction:row;align-items:center;& > span{", (0,fontStyles/* body1Font */.Nr)(), "    margin:0 12px;}");
var StyledDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Divider/* default */.Z, {
    target: "e9fhi72"
})("margin:0px 16px;height:24px;");

// EXTERNAL MODULE: ./src/styles/Layout.tsx
var Layout = __webpack_require__(622);
;// CONCATENATED MODULE: ./src/pages/index.page.tsx








function HomePage() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContainer/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HomePageLayout, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(home_StatusBarContainer, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(home_RecruitPostsContainer, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var index_page = (HomePage);
var HomePageLayout = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Layout/* default */.Z, {
    target: "e111v0230"
})((0,responsive/* mq2 */.v6)({
    width: [
        "calc(100% - 40px)",
        "calc(100% - 40px)",
        "calc(100% - 40px)",
        "800px",
        "1040px"
    ]
}), ";");


/***/ }),

/***/ 4405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);

var Divider = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e1ai529i0"
})("width:1px;min-width:1px;height:10px;background:", function(param) {
    var theme = param.theme;
    return theme.accent3;
}, ";margin:0px 8px;border-radius:1px;");
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 28598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ removeAllHtml; },
/* harmony export */   "v": function() { return /* binding */ filteredWithSanitizeHtml; }
/* harmony export */ });
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_0__);

var filteredWithSanitizeHtml = function(dirtyHtml) {
    return sanitize_html__WEBPACK_IMPORTED_MODULE_0___default()(dirtyHtml, {
        allowedTags: [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "dd",
            "div",
            "dl",
            "dt",
            "figcaption",
            "figure",
            "hr",
            "li",
            "main",
            "ol",
            "p",
            "pre",
            "ul",
            "a",
            "abbr",
            "b",
            "bdi",
            "bdo",
            "br",
            "cite",
            "code",
            "data",
            "dfn",
            "em",
            "i",
            "kbd",
            "mark",
            "q",
            "rb",
            "rp",
            "rt",
            "rtc",
            "ruby",
            "s",
            "samp",
            "small",
            "span",
            "strong",
            "sub",
            "sup",
            "time",
            "u",
            "var",
            "wbr",
            "caption",
            "col",
            "colgroup",
            "table",
            "tbody",
            "td",
            "tfoot",
            "th",
            "thead",
            "tr",
            "strike",
            "img",
            "del",
            "input", 
        ],
        disallowedTagsMode: "discard",
        allowedAttributes: {
            a: [
                "href",
                "name",
                "target",
                "rel",
                "data-link-auto"
            ],
            img: [
                "src",
                "srcset",
                "alt",
                "title",
                "width",
                "height",
                "loading"
            ],
            "*": [
                "class",
                "id",
                "aria-hidden"
            ],
            pre: [
                "spellcheck"
            ],
            code: [
                "data-code-block-language"
            ],
            input: [
                "type"
            ]
        },
        selfClosing: [
            "img",
            "br",
            "hr",
            "area",
            "base",
            "basefont",
            "input",
            "link",
            "meta"
        ],
        allowedSchemes: [
            "http",
            "https",
            "ftp",
            "mailto",
            "tel"
        ],
        allowedSchemesByTag: {},
        allowedSchemesAppliedToAttributes: [
            "href",
            "src",
            "cite"
        ],
        allowProtocolRelative: true,
        enforceHtmlBoundary: false
    });
};
var removeAllHtml = function(content) {
    return sanitize_html__WEBPACK_IMPORTED_MODULE_0___default()(content, {
        allowedTags: [],
        allowedAttributes: {}
    });
};


/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [378,129,515,686,313,104,608,774,888,179], function() { return __webpack_exec__(89208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);